// Estado "pensando" — línea editorial digna, sin spinner ruidoso.
//
// HONESTIDAD: el backend NO tiene streaming (POST /api/jido/chat responde
// completo), así que NO podemos mostrar los pasos reales del agente ReAct.
// Rotamos 2-3 frases genéricas pero dignas para dar sensación de progreso.
// Mostrar los pasos concretos (tool calls, iteraciones) requiere streaming
// desde el agente — queda para una fase futura.
//
// Accesibilidad: la rotación y el cursor parpadeante se apagan con
// prefers-reduced-motion.

import { useEffect, useState } from 'react';

const FRASES = [
  'Consultando datos de producción…',
  'Revisando cumplimiento y paros…',
  'Preparando la respuesta…',
] as const;

const INTERVALO_MS = 2600;

export function EstadoPensando() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    // Respetar prefers-reduced-motion: si el usuario lo pide, no rotamos.
    // `matchMedia` puede no existir (jsdom / entornos sin DOM completo) — guardar
    // el typeof evita un crash del panel por una preferencia de motion.
    const prefiereQuieto =
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefiereQuieto) return;

    const timer = window.setInterval(() => {
      setIdx((i) => (i + 1) % FRASES.length);
    }, INTERVALO_MS);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="mr-auto max-w-[85%]" role="status" aria-live="polite">
      <p className="text-sm text-fg-secondary">
        {FRASES[idx]}
        <span className="ml-0.5 animate-pulse font-mono text-fg-tertiary motion-reduce:animate-none">
          ▋
        </span>
      </p>
    </div>
  );
}
